import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { DatiPagamentoDTO } from "../dto/dati-pagamentoDTO";
import { DatiPagamentoVO } from "../vo/dati-pagamentoVO";
import { MapperDocumento } from "./mapper-documento";

@Injectable({ providedIn: "root" })
export class MapperDatiPagamento implements MapperInterface<DatiPagamentoDTO, DatiPagamentoVO> {
  constructor(private documentoMapper: MapperDocumento) { }

  convertVoToDto(datiPagamentoVO: DatiPagamentoVO): DatiPagamentoDTO {
    // console.log("[MapperSettore] NormaVO => NormaDTO", normaVO);
    const datiPagamentoDTO = new DatiPagamentoDTO();

    datiPagamentoDTO.dataPagamento = datiPagamentoVO.dataPagamento;
    datiPagamentoDTO.quietanzaPagamento = this.documentoMapper.convertVoToDto(datiPagamentoVO.quietanzaPagamento);
    // console.log("return", normaDTO);
    return datiPagamentoDTO || new DatiPagamentoDTO();
  }

  convertDtoToVo(datiPagamentoDTO: DatiPagamentoDTO): DatiPagamentoVO {
    if (datiPagamentoDTO != null) {
      const datiPagamentoVO = new DatiPagamentoVO();

      datiPagamentoVO.dataPagamento = datiPagamentoDTO.dataPagamento;
      datiPagamentoVO.quietanzaPagamento = this.documentoMapper.convertDtoToVo(datiPagamentoDTO.quietanzaPagamento);

      return datiPagamentoVO || new DatiPagamentoVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(datiPagamentoVOList: DatiPagamentoVO[]): DatiPagamentoDTO[] {
    if (datiPagamentoVOList != null) {
      const datiPagamentoDTOList = new Array<DatiPagamentoDTO>();
      datiPagamentoVOList.forEach((vo) => {
        datiPagamentoDTOList.push(this.convertVoToDto(vo));
      });
      return datiPagamentoDTOList || new Array<DatiPagamentoDTO>();
    } else {
      return null;
    }
  }

  convertListDtoToVo(datiPagamentoDTOList: DatiPagamentoDTO[]): DatiPagamentoVO[] {
    if (datiPagamentoDTOList != null) {
      const datiPagamentoVOList = new Array<DatiPagamentoVO>();
      datiPagamentoDTOList.forEach((dto) => {
        datiPagamentoVOList.push(this.convertDtoToVo(dto));
      });
      return datiPagamentoVOList;
    } else {
      return null;
    }
  }
}
